import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-confirm-modal',
	templateUrl: './confirm-modal.component.html',
	styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {
	@Input() iConfirmModal: boolean = false;
	@Input() title: string = "";
	@Input() description: string = "";
	@Output() onAction: EventEmitter<boolean> = new EventEmitter<boolean>();

	public setting = { showCloseIcon: false, backdropClick: false };

	action(status: string) {
		this.onAction.emit((status == 'yes') ? true : false);
		document.body.style.overflow = "auto";
	}
}
